module.exports = __webpack_public_path__ + "img/gruppi_hdtol.92a30aff.png";